

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AdminView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminAdmins } from "@/lib/query/core/invalidation";

type CreateAdminInput = {
  name: string;
  email: string;
  phone: string;
  password: string;
  roles?: string[];
};

export function useCreateAdminMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateAdminInput) =>
      apiJsonClient<AdminView>(endpoints.admin.admins, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: async () => {
      await invalidateAdminAdmins(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
